import { getSingleton } from '../utils/singleton';

export function getService<C>(fnOrClass: (() => C) | (new () => C)): C {
  return getSingleton(fnOrClass);
}
